<template>
  <div class="guide-open">
    <div class="wrapper">
      <div class="container">
        <div class="user-package-info">
          <div class="tit">当前套餐</div>
          <div class="pack-intro">
            您现在使用的主套餐是 {{userPackage.main_offer_name}}
            <em
              v-if="userPackage.pkg_fee"
            >，资费为{{userPackage.pkg_fee}}</em>
          </div>
        </div>
        <div class="recom-package">
          <div class="tit">
            <img src="../../assets/img/hornor-buy/fire-icon.png" />
            套餐升级推荐
          </div>
          <div class="package-list">
            <button
              :class="{checked: index === current}"
              :key="index"
              @click="switchTab(index)"
              class="package-item"
              v-for="(meal, index) in mealList"
            >
              <div class="check-status"></div>
              <p>
                {{meal.title}}，{{meal.exp}}，
                <em>{{meal.award}}</em>
              </p>
            </button>
          </div>
        </div>
        <div class="footer">
          <div class="open-order">
            <button @click="bookingHandler">预约办理</button>
          </div>
          <div class="check-status">
            <button :class="{'checked': checked} " @click="swichCheck" class="unchecked"></button>
            <span>同意营业厅联系我办理信用购</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let flag = false
export default {
  name: 'hornoBuyGuideOpen',

  data () {
    return {
      current: 0,
      checked: true,
      userPackage: {},
      mealList: []

    }
  },
  computed: {
    packageMoney () {
      return this.mealList.length && this.mealList.find((v, i) => i === this.current).money
    }
  },
  created () {
    this.getUserRecommend()
    this.getUserPackage()
  },
  methods: {
    switchTab (i) {
      this.current = i
    },
    swichCheck () {
      this.checked = !this.checked
    },

    /**
     * 获取用户套餐详情
     */
    async getUserPackage () {
      const res = await this.$axios.get('/api/member/pkg')
      if (res.status === 200) {
        this.userPackage = res.data
      }
    },
    async bookingHandler () {
      if (!this.checked) {
        this.$toast('请勾选同意营业厅联系我办理信用购')
        return false
      }
      if (flag) {
        return false
      }
      flag = true

      const status = await this.upgradePackageHandler({
        'type': 'rev',
        'buz_id': this.packageMoney,
        'allow_contact': this.checked * 1
      })
      flag = false
      if (status) {
        this.$router.push({ name: 'hornorBuyGuiteEnquiries' })
      } else {
        return false
      }
    },
    /**
     * 办理升档
     */
    async upgradePackageHandler (params) {
      this.$toast.loading('正在办理,请稍后...')
      const res = await this.$axios.post('api/business/rev', params)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg } = res.data
        if (code === 8105 || code === 0) {
          this.$toast('预约申请提交成功')
          return true
        } else {
          this.$toast(msg)
          return false
        }
      }
    },

    /**
     * 获取用户推荐
     */
    async getUserRecommend () {
      this.$toast.loading('正在加载...')
      const res = await this.$axios.get('api/business/mr')
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data } = res.data
        if (code === 0) {
          this.recommendMeal = data.top_member
          this.mealList = data.list
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.guide-open {
  width: 100%;
  min-height: 13.34rem;
  background: url("../../assets/img/hornor-buy/hornor-banner.png") top no-repeat
    #e62717;
  background-size: 100% 9.84rem;
  padding-bottom: 0.74rem;
  .wrapper {
    padding: 8.55rem 0.3rem 0;
    .container {
      padding: 0.4rem 0.3rem;
      margin: 0 auto 0;
      background-color: #fff;
      border-radius: 8px;
      .user-package-info {
        position: relative;
        padding: 0.5rem 0.3rem;
        font-size: 0.26rem;
        color: #575757;

        border: 0.02rem solid #a7c3e4;
        border-radius: 0.14rem;
        .tit {
          position: absolute;
          .flex-center;
          width: 1.38rem;
          height: 0.38rem;
          background-color: #66a6ff;
          border-radius: 30px;
          font-size: @fz24;
          color: #fff;
          top: -0.18rem;
          left: 0.3rem;
        }
      }
      .recom-package {
        .tit {
          font-size: @fz32;
          color: #e62717;
          font-weight: bold;
          .flex-center;
          padding: 0.3rem 0 0.4rem;
          img {
            width: 0.49rem;
            height: 0.5rem;
            padding-right: 0.1rem;
          }
        }
        .package-list {
          .flex-column-center;
          width: 100%;
          .package-item {
            position: relative;
            width: 100%;
            height: 0.93rem;
            margin-bottom: 0.3rem;
            background: linear-gradient(
              180deg,
              rgba(255, 255, 255, 1) 0%,
              rgba(242, 242, 242, 1) 100%
            );
            border: 1px solid rgba(235, 235, 235, 1);
            border-radius: 0.14rem;
            font-size: @fz28;
            color: @base;
            &:first-child::before {
              content: "";
              position: absolute;
              width: 0.79rem;
              height: 0.49rem;
              background: url("../../assets/img/hornor-buy/tj.png") center
                no-repeat;
              background-size: 100%;
              top: 0;
              right: 0;
            }
            &::after {
              content: "";
              position: absolute;
              width: 0.36rem;
              height: 0.36rem;
              background: url("../../assets/img/hornor-buy/package-uncheck.png")
                center no-repeat;
              background-size: 100%;
              left: 0.2rem;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          .checked {
            color: #e62717;
            background: linear-gradient(
              180deg,
              rgba(255, 255, 255, 1) 0%,
              rgba(255, 226, 220, 1) 100%
            );
            border: 1px solid#FFE2DC;
            &::after {
              background: url("../../assets/img/hornor-buy/package-checked.png")
                center no-repeat;
              background-size: 100%;
            }
          }
        }
      }
    }
  }
  .footer {
    .open-order {
      width: 6.3rem;
      height: 0.92rem;
      margin: 0 auto 0.33rem;
      button {
        width: 100%;
        height: 100%;
        background-image: linear-gradient(
          180deg,
          #ffab70 1%,
          #ff776b 3%,
          #e62717 100%
        );
        border-radius: 0.14rem;
        border-radius: 8px;
        font-size: 0.34rem;
        color: #fff;
      }
    }
    .check-status {
      padding: 0 0.3rem;
      font-size: @fz24;
      color: @c80;
      display: flex;
      align-items: center;
      .unchecked,
      .checked {
        width: 0.32rem;
        height: 0.32rem;
        background: url("../../assets/img/hornor-buy/agree-def.png") center
          no-repeat;
        background-size: 100%;
      }
      .checked {
        background: url("../../assets/img/hornor-buy/agreed.png") center
          no-repeat;
        background-size: 100%;
      }
      span {
        padding-left: 0.15rem;
      }
    }
  }

  .dialog {
    .desc {
      padding: 0.3rem 0;
      text-align: center;
      font-size: @fz26;
      color: #000;
      line-height: 2;
      padding-bottom: 0.5rem;
    }
  }
}
</style>
